import React, { ElementType, MouseEventHandler, ReactNode } from 'react'
import { ListItemButton as MUIListItemButton, SxProps } from '@mui/material'
import { Color } from 'themes'

import LinkWrapper from 'components_new/atoms/LinkWrapper'

interface ListItemButtonProps {
  alignItems?: 'center' | 'flex-start'
  className?: string
  color?: 'brand' | Color
  children: ReactNode
  component?: ElementType<any>
  dense?: boolean
  disabled?: boolean
  disableGutters?: boolean
  disableHistory?: boolean
  disableRipple?: boolean
  divider?: boolean
  href?: string
  id?: string
  newTab?: boolean
  onClick?: (() => void) | MouseEventHandler<HTMLElement>
  onMouseDown?: (() => void) | MouseEventHandler<HTMLElement>
  onMouseMove?: (() => void) | MouseEventHandler<HTMLElement>
  role?: string
  selected?: boolean
  search?: string
  sx?: SxProps
}

const ListItemButton = React.forwardRef(
  (props: ListItemButtonProps, ref: any) => {
    const {
      children,
      disabled,
      disableHistory,
      href,
      newTab,
      search,
      ...rest
    } = props

    return (
      <LinkWrapper
        disabled={disabled}
        disableHistory={disableHistory}
        href={href}
        newTab={newTab}
        search={search}
        style={{ width: '100%' }}
      >
        <MUIListItemButton
          disabled={disabled}
          sx={{ whiteSpace: 'nowrap' }}
          {...rest}
          ref={ref}
        >
          {children}
        </MUIListItemButton>
      </LinkWrapper>
    )
  }
)

ListItemButton.displayName = 'ListItemButton'
export default ListItemButton
